<script setup>
import { AnnStore } from '@/front/stores/ann_store.js';
const annStore = AnnStore();

import { PlayerStore } from '@/front/stores/player_store.js';
const playerStore = PlayerStore();

import { VideoStore } from '@/front/stores/video_store.js';
const videoStore = VideoStore();

import { DesignStore } from '@/front/stores/design_store.js';
const designStore = DesignStore();
import ListButton from '@/front/components/annotations/ListButton.vue';
import ListHotspot from '@/front/components/annotations/ListHotspot.vue';
import ListImage from '@/front/components/annotations/ListImage.vue';
import ListText from '@/front/components/annotations/ListText.vue';
import ListQuestion from '@/front/components/annotations/ListQuestion.vue';
import ListOther from '@/front/components/annotations/ListOther.vue';
import { useGlobalRenderTracker } from '@/front/composables/GlobalRenderTracker.js'
import { HelpCircleIcon } from 'hugeicons-vue';
if (playerStore.isDebugPerformance) {
  useGlobalRenderTracker('MarkerBar', { logLevel: 'none' })
}

const markers = ref([])

onMounted(() => {
  // log.info(5,"markerBar onMounted")
  setTimeout(() => {
    markers.value = []
    annStore.visibleMainAnns.forEach(ann => {
      let obj = Object.assign({}, ann)
      obj.style = getStyle(obj, null)
      // log.info(5,"Marker at time " + obj.exact_time + " is at " + obj.style.left + " (Duration: " + playerStore.safeDuration + ")")
      markers.value.push(obj)
    })
  }, 10)
})

const getStyle = (ann, hoverAnn) => {
  if (!playerStore.safeDuration) return {}
  const p = 100*ann.exact_time / playerStore.safeDuration
  const padding = 15.5
  const defaultWidth = 12
  const borderWidth = 2
  // const l = p * (slider.value.clientWidth - defaultWidth/2 + borderWidth) + slider.value.offsetLeft
  const w = (ann.exact_finish - ann.exact_time) / playerStore.safeDuration * 100
  return {
    left: `${p}%`,
    backgroundColor: videoStore.video.design.color,
    opacity: false && hoverAnn && hoverAnn.id === ann.id ? 0.3 : 1,
    width: false && hoverAnn && hoverAnn.id === ann.id? `${w}%` : `${defaultWidth}px`,
    minWidth: `${defaultWidth}px`
  }
}


const clickMarker = (ann) => {
  // Don't seek if seeking turned off
  if (!videoStore.video.design.seekbar_active && !videoStore.video.manage) {
    return
  }
  log.info(5,"clickMarker", ann)
  log.info(5,ann.exact_time, playerStore.safeDuration, ann.exact_time / playerStore.safeDuration * 100)
  playerStore.seek(ann.exact_time)
}

const getTooltipsStyle = (ann, markerAnn) => {
  const style = {
    display: markerAnn && markerAnn.id === ann.id ? 'flex' : 'none',
    position: 'absolute',
    top: '-120px',
    left: '50%',
    transform: 'translateX(-50%)',
    height: '100px',
  }
  return style
}

const doMarkerHover = (ann) => {
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || ann.type_of == 'question') return
  annStore.startMarkerHover(ann)
}

const doMarkerLeave = () => {
  annStore.endMarkerHover()
}

</script>

<template>
  <!-- <div v-if="annStore" id="marker-bar" class="absolute w-full h-96 flex items-center" b> -->
    <div 
      v-for="ann in annStore.visibleMainAnns" 
      @click.stop.prevent="clickMarker(ann)"
      :key="ann.id" 
      @mouseenter.stop="doMarkerHover(ann)"
      @mouseleave.stop="doMarkerLeave()" 
      :style="getStyle(ann, annStore.hoverAnn)"
      class="h-6 absolute rounded-lg border-2 border-white -ml-1 z-10 cursor-pointer !bg-[var(--user-theme-color)]" 
      :id="`marker-${ann.id}`"
      >
      <div v-if="annStore.markerAnn" :style="getTooltipsStyle(ann, annStore.markerAnn)" class="absolute top-0 left-0 items-center justify-center bg-white rounded-lg shadow-md w-auto min-w-[200px] text-xs px-4 text-black"> 
        <ListButton v-if="ann.type_of == 'button'" :ann="ann" />
        <ListHotspot v-else-if="ann.type_of == 'hotspot'" :ann="ann" />
        <ListImage v-else-if="ann.type_of == 'image'" :ann="ann" />
        <ListText v-else-if="ann.type_of == 'text'" :ann="ann" />
        <ListOther v-else-if="ann.type_of != 'question'" :ann="ann" />
      </div>
    </div>
  <!-- </div> -->
</template>
